import { Section, Row } from "./ReportUIPrimitives";
import styles from "./HistoricalOrdersViewer.module.css";

const fmtNumber = (value) => {
  if (value === null || value === undefined) return "—";
  const num = typeof value === "number" ? value : Number(value);
  return Number.isFinite(num) ? num.toLocaleString() : "—";
};

const fmtMoney = (value, currency = "USD") => {
  if (value === null || value === undefined) return "—";
  const num = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(num)) return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return num.toFixed(2);
  }
};

const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
};

const HistoricalOrdersViewer = ({ data = {} }) => {
  const currency = data.currency_code || "USD";
  const salesByYear = Array.isArray(data.sales_by_year) ? data.sales_by_year : [];
  const topProducts = Array.isArray(data.top_products) ? data.top_products : [];
  const highest = data.highest_returning_customer || {};

  return (
    <div className={styles.container}>
      <Section title="Summary">
        <div className={styles.summaryGrid}>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>Orders</span>
            <span className={styles.summaryValue}>{fmtNumber(data.order_count)}</span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>Currency</span>
            <span className={styles.summaryValue}>{currency || "—"}</span>
          </div>
          <div className={styles.summaryCard}>
            <span className={styles.summaryLabel}>Generated</span>
            <span className={styles.summaryValue}>{formatDate(data.generated_at)}</span>
          </div>
        </div>
      </Section>

      <Section title="Sales by Year">
        <div className={styles.table}>
          <div className={styles.tableHeader}>
            <span>Year</span>
            <span>Total Orders</span>
            <span>Total Sales</span>
          </div>
          {salesByYear.length ? (
            salesByYear.map((row) => (
              <div key={row.year} className={styles.tableRow}>
                <span>{row.year}</span>
                <span>{fmtNumber(row.total_orders)}</span>
                <span>{fmtMoney(row.total_sales, currency)}</span>
              </div>
            ))
          ) : (
            <div className={styles.empty}>No yearly sales data.</div>
          )}
        </div>
      </Section>

      <Section title="Top Customer">
        {highest?.email ? (
          <div className={styles.customerCard}>
            <Row label="Name" value={`${highest.first_name || ""} ${highest.last_name || ""}`.trim() || "—"} />
            <Row label="Email" value={highest.email || "—"} />
            <Row label="Total Orders" value={fmtNumber(highest.total_orders)} />
            <Row label="Total Spent" value={fmtMoney(highest.total_spent, currency)} />
          </div>
        ) : (
          <div className={styles.empty}>No returning customer data.</div>
        )}
      </Section>

      <Section title="Top Products">
        {topProducts.length ? (
          <div className={styles.productsGrid}>
            {topProducts.map((item, idx) => (
              <div key={`${item.title}-${idx}`} className={styles.productCard}>
                <h5 className={styles.productTitle}>{item.title || "Product"}</h5>
                <Row label="Quantity" value={fmtNumber(item.total_quantity)} />
                <Row label="Revenue" value={fmtMoney(item.total_revenue, currency)} />
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.empty}>No top products available.</div>
        )}
      </Section>
    </div>
  );
};

export default HistoricalOrdersViewer;
